export default {
	// Tab labels
	assetsWithDefects: "Activos con Defectos",
	repairs: "Reparaciones",
	repairTime: "Tiempo de Reparación",

	// Page titles
	assetsWithOpenDefects: "Activos con Defectos Abiertos",
	repairsReport: "Informe de Reparaciones",
	repairTimeReport: "Informe de Tiempo de Reparación",
	openDefectDetails: "Detalles de Defectos Abiertos",
	defectsFor: "Defectos para {assetFleet}",

	// Column headers
	asset: "Activo",
	homeLocation: "Ubicación Principal",
	type: "Tipo",
	manufacturer: "Fabricante",
	vin: "VIN",
	lastInspection: "Última Inspección",
	currentZone: "Zona Actual",
	status: "Estado",
	defects: "Defectos",
	actions: "Acciones",
	zone: "Zona",
	component: "Componente",
	condition: "Condición",
	severity: "Severidad",
	mechanic: "Mecánico",
	soNumber: "Número de O.S.",
	inspectionDate: "Fecha de Inspección",
	count: "Cantidad",
	tags: "Etiquetas",

	// Filter labels
	configType: "Tipo de Inspección",
	allTypes: "Todos los Tipos",
	location: "Ubicación",
	assetType: "Tipo de Activo",
	allAssetTypes: "Todos los Tipos de Activo",
	defectStatus: "Estado del Defecto",
	showAll: "Mostrar todos",
	open: "Abierto",
	pending: "Pendiente",
	allZones: "Todas las Zonas",
	allComponents: "Todos los Componentes",
	allConditions: "Todas las Condiciones",
	startDate: "Fecha de Inicio",
	endDate: "Fecha de Fin",
	clear: "Limpiar",
	typeToSearch: "Escriba para buscar...",
	noLocationsFound: "No se encontraron ubicaciones",
	noLocationsAvailable: "No hay ubicaciones disponibles",
	noAssetsFound: "No se encontraron activos",
	noAssetsAvailable: "No hay activos disponibles",
	noZonesFound: "No se encontraron zonas",
	noComponentsFound: "No se encontraron componentes",
	noConditionsFound: "No se encontraron condiciones",
	closedStatus: "Cerrado",

	// Button labels
	exportCSV: "Exportar CSV",
	view: "Ver",
	viewDefects: "Ver Defectos",
	back: "Volver",
	repairSelected: "Reparar Seleccionados ({count})",
	addRepair: "Agregar Reparación",
	collapse: "Contraer",
	expand: "Expandir",

	// Summary card labels
	criticalDefects: "Defectos Críticos",
	nonCriticalDefects: "Defectos No Críticos",
	totalDefects: "Total de Defectos",
	criticalRepairs: "Reparaciones Críticas",
	nonCriticalRepairs: "Reparaciones No Críticas",
	totalRepairs: "Total de Reparaciones",
	averageRepairTime: "Tiempo Promedio de Reparación",
	fastestRepair: "Reparación Más Rápida",
	longestRepair: "Reparación Más Larga",

	// Severity labels
	critical: "Crítico",
	nonCritical: "No Crítico",

	// Empty states
	noAssetsWithOpenDefects: "No hay activos con defectos abiertos",
	tryAdjustingFilters: "Intente ajustar sus filtros",
	noRepairsFound: "No se encontraron reparaciones",
	tryAdjustingDateRange: "Intente ajustar el rango de fechas o los filtros",
	noRepairDataFound: "No se encontraron datos de reparación",
	noOpenDefects: "No hay defectos abiertos",
	allDefectsResolved: "Todos los defectos han sido resueltos",

	// Expanded row content
	repairNotes: "Notas de Reparación",
	noNotesProvided: "No hay notas proporcionadas",

	// Misc
	assets: "activos",
	noGps: "Sin GPS",
	na: "N/D",

	pending: "Pendiente",
	repairNotNeeded: "No se necesitan reparaciones",
	repaired: "Reparado",
};
